import { graphql } from "../generated";

export const UNLIKE = graphql(`
  mutation Unlike($id: ID!, $percentage: Float!) {
    unlike(id: $id, percentage: $percentage) {
      id
      liked
      likes
    }
  }
`);
